import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { checkSchedulingVisibility } from '../utils'
import { useSchedulingEnabled } from './useSchedulingEnabled'
import { selectEntityAppointmentsSearch } from '../searchSlice'
import type { IScheduleSettingsDetail } from '@user/store/closingRequirements'
import { useGetEntitiesWithAppointment } from './useGetEntitiesWithAppointment'
import { useGetAppointmentsSearchDataOnMount } from './useGetAppointmentsSearchDataOnMount'

type Entity = {
  id: number
  scheduleSettings?: IScheduleSettingsDetail
}

export function useGetAppointmentsDataOnMount<T extends Entity>(
  entityType: number,
  entities: T[],
) {
  const schedulingEnabled = useSchedulingEnabled()

  const appointmentsSearch = useSelector(selectEntityAppointmentsSearch)

  const entityIds = useMemo(() => {
    const enabled = entities.some(({ scheduleSettings }) =>
      checkSchedulingVisibility(scheduleSettings),
    )
    return enabled ? entities.map((e) => e.id) : []
  }, [entities])

  const appointmentsLoading = useGetAppointmentsSearchDataOnMount(
    entityIds,
    entityType,
    schedulingEnabled,
  )

  const appointmentsMap = useGetEntitiesWithAppointment(
    entityIds,
    appointmentsSearch,
    schedulingEnabled,
  )

  return {
    appointmentsMap,
    appointmentsLoading,
  }
}
